<div dropdown class="topbar-item" data-toggle="dropdown" aria-expanded="true"
    [dropup]="isDropup" container="{{isDropup ? null: 'body'}}" >
    <div dropdownToggle [class]="customStyle" id="notificationIcon">
        <i class="flaticon-alert-2 unread-notification" *ngIf="unreadNotificationCount"></i>
        <span class="label label-warning unread-notification-count" *ngIf="unreadNotificationCount">
            {{unreadNotificationCount}}
        </span>
        <i class="flaticon-alarm" *ngIf="!unreadNotificationCount"></i>
    </div>
    <div *dropdownMenu
        class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-sm dropdown-menu-lg">
        <perfect-scrollbar>
            <div class="d-flex flex-column pt-12 bgi-size-cover bgi-no-repeat rounded-top"
                [ngStyle]="{ 'background': 'url(' + appRootUrl() + 'assets/metronic/themes/default/images/bg/bg-1.jpg)', 'background-size': 'cover'}">
                <h4 class="d-flex flex-center rounded-top">
                    <span class="text-white">{{"Notifications" | localize}}</span>
                    <span
                        class="btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2">{{unreadNotificationCount}}
                        {{"New" | localize}}</span>
                </h4>
            </div>
            <div>
                <div class="row m-4">
                    <div class="text-left col-md-8">
                        <a href="javascript:;"
                            (click)="setAllNotificationsAsRead(); $event.preventDefault(); $event.stopPropagation();"
                            id="setAllNotificationsAsReadLink"
                            *ngIf="unreadNotificationCount">{{"SetAllAsRead" | localize}}</a>
                    </div>
                    <div class="text-right col-md-4">
                        <a id="openNotificationSettingsModalLink" class="text-right" href="javascript:;"
                            (click)="openNotificationSettingsModal()">{{"Settings" | localize}}</a>
                    </div>
                </div>
                <hr />

                <div class="navi navi-hover my-4 ps" data-scroll="true" data-height="300" data-mobile-height="200"
                    style="height: 300px; overflow: hidden;">

                    <a *ngFor="let notification of notifications" (click)="gotoUrl(notification.url)"
                        [ngClass]="{'user-notification-item-clickable': notification.url,'user-notification-item-unread': notification.isUnread}"
                        class="navi-item">
                        <div class="navi-link">
                            <div class="navi-icon mr-2">
                                <i class="{{notification.icon}} {{notification.iconFontClass}}"></i>
                            </div>
                            <div class="navi-text">
                                <div class="font-weight-bold">
                                    {{notification.text}}
                                </div>
                                <div class="text-muted">
                                    {{notification.creationTime | luxonFromNow}}
                                </div>
                                <span *ngIf="notification.isUnread"
                                    class="btn btn-link-success set-notification-as-read"
                                    (click)="setNotificationAsRead(notification); $event.preventDefault(); $event.stopPropagation();">
                                    {{"SetAsRead" | localize}}
                                </span>
                            </div>
                        </div>
                    </a>
                    <span *ngIf="!notifications.length" class="notification-empty-text p-3">
                        {{"ThereAreNoNotifications" | localize}}
                    </span>
                </div>
                <hr *ngIf="notifications.length" />
                <div class="m-4" *ngIf="notifications.length">
                    <div class="text-center"><a routerLink="notifications">{{"SeeAllNotifications" | localize}}</a>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </div>
</div>
